(function () {
    'use strict';

    function workflowRoadmapController($scope, $rootScope, $document,
        $uibModal, $timeout, milestones, sessionData, roadmapThumbnails,
        workflowStateService, workflowConfigurationDataService, toastr, notifyService, milestoneModalService, $pbService) {

        var vm = this;
        vm.workflowData = workflowStateService.get();
        vm.workflowId = vm.workflowData.Id.split('/')[1];
        vm.copyTogglesEnabled = true;
        vm.roadmapThumbnails = roadmapThumbnails;

        vm.workflowData.Phases.forEach(function (phase, index) {
            var commentPopoverClass = 'comments-menu-popover-' + index;
            phase.popoverConfig = {
                id: 'roadmapPhaseComments' + index,
                class: 'comments-menu-popover ' + commentPopoverClass,
                placement: 'bottom',
                template: 'workflow/templates/commentsMenuPopover.html',
                outsideSelector: 'div.' + commentPopoverClass,
                outsideIgnoreSelector: 'button.' + commentPopoverClass
            }
        });

        var partnerPopoverClass = 'phase-partner-selector-popover';
        vm.projectPartnersPopoverConfig = {
            id: 'roadmapPhasePartners',
            class: 'partner-selector-popover ' + partnerPopoverClass,
            placement: 'left',
            template: 'workflow/templates/partnerSelectorPopover.html',
            outsideSelector: 'div.' + partnerPopoverClass,
            outsideIgnoreSelector: 'button.' + partnerPopoverClass
        }

        milestoneModalService.getMilestonesAndTemplates(milestones).then(function (milestonesAndTemplates) {
            if (milestonesAndTemplates.length > 0) {
                milestoneModalService.openModal(milestonesAndTemplates);
            }
        });

        //$scope.$on('workflowUpdated', function () {
        //    vm.workflowData = workflowStateService.get();
        //});

        vm.tinymceOptions = {
            height: "300",
            menubar: false,
            statusbar: false,
            resize: false,
            plugins: [
                "advlist autolink link paste"
            ],
            advlist_bullet_styles: "disc",
            toolbar: "undo redo | bold italic | bullist | link",
            valid_elements: '*[*]',
            debounce: true
        };

        vm.showRemovePhasePrompt = function showRemovePhasePrompt(phaseIndex) {
            var modalInstance = $uibModal.open({
                templateUrl: 'removePhaseModal',
                controller: 'removePhaseModalController',
                resolve: {
                    phaseIndex: function () {
                        return phaseIndex;
                    },
                    phaseTitle: function () {
                        return vm.workflowData.Phases[phaseIndex].Title;
                    }
                }
            });

            return modalInstance.result.then(function (removePhase) {
                if (removePhase) {
                    vm.workflowData.Phases[phaseIndex].IsRemoved = true;
                    workflowStateService.update(vm.workflowData);
                    notifyService.notify(
                        'You have removed the phase ' + vm.workflowData.Phases[phaseIndex].Title);
                }
            });
        }

        vm.toggleWorkflowReorderMode = function () {
            if (!$rootScope.workflowReorderMode) {
                $rootScope.workflowReorderModeToast = toastr.info('You are currently reordering the workflow phases',
                    {
                        timeOut: 0,
                        extendedTimeOut: 0,
                        closeButton: true,
                        closeHtml: "<button>Stop reordering</button>",
                        onHidden: function () {
                            $rootScope.workflowReorderMode = false;
                        }
                    });
            } else {
                if ($rootScope.workflowReorderModeToast) {
                    toastr.clear($rootScope.workflowReorderModeToast);
                    delete $rootScope.workflowReorderModeToast;
                }
            }

            $rootScope.workflowReorderMode = !$rootScope.workflowReorderMode;
        }

        vm.activateEditPhaseHeaderCopy = function (phaseIndex) {
            if (!vm.workflowData.Phases[phaseIndex].HeaderCopyHtmlOverride &&
                !vm.workflowData.Phases[phaseIndex].HeaderCopyHtmlTemplateId) {
                vm.workflowData.Phases[phaseIndex].HeaderCopyHtmlOverride = 'Please complete the information below';
                vm.workflowData.Phases[phaseIndex].OriginalHeaderCopyHtmlOverride = null;
                vm.workflowData.Phases[phaseIndex].isEditingHeaderCopy = true;
            }
            else if (vm.workflowData.Phases[phaseIndex].HeaderCopyHtmlOverride) {
                vm.workflowData.Phases[phaseIndex].OriginalHeaderCopyHtmlOverride =
                    vm.workflowData.Phases[phaseIndex].HeaderCopyHtmlOverride;
                vm.workflowData.Phases[phaseIndex].isEditingHeaderCopy = true;
            }
            else {
                workflowConfigurationDataService.loadHtmlTemplate(
                    vm.workflowData.Phases[phaseIndex].HeaderCopyHtmlTemplateId).then(function (data) {
                        vm.workflowData.Phases[phaseIndex].HeaderCopyHtmlOverride = data.Html;
                        vm.workflowData.Phases[phaseIndex].OriginalHeaderCopyHtmlOverride = data.Html;
                        vm.workflowData.Phases[phaseIndex].isEditingHeaderCopy = true;
                    });
            }
        }

        vm.closeEditPhaseHeaderCopy = function (phaseIndex, save) {
            vm.workflowData.Phases[phaseIndex].isEditingHeaderCopy = false;
            if (!save) {
                vm.workflowData.Phases[phaseIndex].HeaderCopyHtmlOverride =
                    vm.workflowData.Phases[phaseIndex].OriginalHeaderCopyHtmlOverride;
            }
            else {
                workflowStateService.update(vm.workflowData);
            }

            $rootScope.$emit('roadmapHtmlTemplateLoaded',
                {
                    triggerMatchData: vm.workflowData.Phases[phaseIndex]
                        .HeaderCopyHtmlTemplateId
                });
        }

        vm.reorderPhases = function (phaseIndex) {
            vm.workflowData.Phases.splice(phaseIndex, 1);
            workflowStateService.update(vm.workflowData);
        }

        vm.activateAddPhase = function () {
            vm.isAddingPhase = true;
        }

        vm.addPhaseData = {
            PhaseTitle: ''
        };

        vm.resetAddPhase = function() {
            vm.isAddingPhase = false;
            vm.addPhaseData.PhaseTitle = ''
        }

        vm.addPhase = function () {
            workflowStateService.addPhase(vm.addPhaseData.PhaseTitle);
            vm.workflowData.Phases.push({
                Title: vm.addPhaseData.PhaseTitle,
                Prompt: vm.addPhaseData.PhaseTitle,
                Status: 'Pending',
                RequiredDownloads: [],
                InformationParts: [],
                PercentageComplete: 0,
                EntitySearchIndex: vm.workflowData.EntitySearchIndex,
                AdminEntitySearchIndex: vm.workflowData.AdminEntitySearchIndex
            });
            vm.resetAddPhase();
        }

        vm.removePhase = function (index) {
            workflowStateService.removePhase(index);
        }

        vm.updatePrompt = function () {
            // This trick makes sure the model is updated before we actually send the update
            $timeout(function () {
                workflowStateService.update(vm.workflowData);
            }, 0);
        }

        $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            $timeout(function () {
                $rootScope.$emit('jumpToComment', { path: toParams.path });
            });
        });
    }

    workflowRoadmapController.$inject = ['$scope', '$rootScope', '$document',
        '$uibModal', '$timeout', 'milestones', 'sessionData', 'roadmapThumbnails',
        'workflowStateService', 'workflowConfigurationDataService', 'toastr', 'notifyService', 'milestoneModalService', '$pbService'];

    angular.module('ecap.workflow').controller('workflowRoadmapController', workflowRoadmapController);
})();
